import React from 'react';

import { useIntl } from 'react-intl-next';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { Flex, xcss } from '@atlaskit/primitives';
import TextField from '@atlaskit/textfield';
import { fireUIAnalytics } from '@atlassian/analytics-bridge';
import { FilterSelect } from '@atlassian/eoc-filter-select';
import { useIsNewNavigation } from '@atlassian/eoc-global-context';

import { type StatusOption, type StatusOptions } from '../../../../common/types';
import { useHeartbeatsContext } from '../../../../controllers/providers/heartbeats';

import messages from './messages';
import { Option } from './options';
import { WrapperTextField } from './styled';

export const STATUS_FILTERS: StatusOptions = [
	{
		label: 'Pending',
		value: 'Pending',
	},
	{
		label: 'Responsive',
		value: 'Responsive',
	},
	{
		label: 'Unresponsive',
		value: 'Unresponsive',
	},
	{
		label: 'Off',
		value: 'Off',
	},
];

export const Filter = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { formatMessage } = useIntl();
	const { filters } = useHeartbeatsContext();
	const isHorizontalNav = useIsNewNavigation();

	return (
		<Flex xcss={!isHorizontalNav && containerStyles} columnGap="space.100">
			<WrapperTextField>
				<TextField
					isCompact
					value={filters.searchText}
					placeholder={formatMessage(messages.searchPlaceholderText)}
					aria-label="Filter"
					onChange={(e) => filters.handleSearchTextChange(e.currentTarget.value)}
					onClick={() => {
						const event = createAnalyticsEvent({});
						fireUIAnalytics(event, 'searchField clicked');
					}}
				/>
			</WrapperTextField>

			<FilterSelect<StatusOption>
				onChange={(value) => filters.handleStatusesChange(value)}
				onClear={() => filters.handleStatusesChange([])}
				value={filters.statuses}
				options={STATUS_FILTERS}
				label={formatMessage(messages.statusLabel)}
				aria-label={formatMessage(messages.statusAriaLabel)}
				formatOptionLabel={(option) => <Option option={option} />}
			/>
		</Flex>
	);
};

const containerStyles = xcss({
	marginTop: 'space.600',
});
